import { apiClient } from './client';

import { events } from './events';
import { users } from './users';

export const api = {
  events: events(apiClient),
  users: users(apiClient),
};
